import Select from "react-select";

function FiltersLabel({ availableLabels, selectedLabel, setSelectedLabel }) {
  return (
    <>
      <label>Filter by Label</label>
      <Select
        options={availableLabels}
        value={selectedLabel}
        onChange={setSelectedLabel}
        className="mb-3"
        isClearable
      />
    </>
  );
}

export default FiltersLabel;
